export default __webpack_public_path__ + "static/media/22.f3d475b0.png";